export function cookiesInit() {
  const getCookie = (cookieName) => {
    let neededCookie = null;
    const cookies = document.cookie.split('; ');
    cookies.forEach((cookie) => {
      const parts = cookie.split('=');
      if (parts[0] === cookieName) {
        neededCookie = parts[1];
      }
    });

    return neededCookie;
  };

  function initCookies() {
    const cookiesContainer = document.querySelector('.cookies');
    if (!cookiesContainer) return;

    if (getCookie('confirmCookie')) {
      cookiesContainer.remove();
      return;
    }

    setTimeout(() => {
      cookiesContainer.classList.add('show');
    }, 1000);

    const cookiesBtn = document.getElementById('cookiesBtn');
    const checkbox = document.querySelector('.cookies__checkbox');

    checkbox.addEventListener('change', () => {
      cookiesBtn.disabled = !checkbox.checked;
    });

    document.querySelector('.cookies__button').onclick = () => {
      cookiesContainer.classList.remove('show');
      cookiesContainer.classList.add('hide');

      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 7);
      const expires = currentDate.toUTCString();
      document.cookie = 'confirmCookie=true; expires=' + expires + '; path=/';

      setTimeout(() => {
        cookiesContainer.remove();
      }, 300);
    };
  }
  initCookies();
}
